import { EntityType } from "api/ux/src";
import { language } from "language/default";
export var WorkspaceEntityType;
(function (WorkspaceEntityType) {
    WorkspaceEntityType["ENTITYTYPE_UNSPECIFIED"] = "ENTITYTYPE_UNSPECIFIED";
    WorkspaceEntityType["PORTFOLIO"] = "PORTFOLIO";
    WorkspaceEntityType["FUND"] = "FUND";
    WorkspaceEntityType["FUND_SERIES"] = "FUND_SERIES";
    WorkspaceEntityType["MANAGER"] = "MANAGER";
    WorkspaceEntityType["ASSET"] = "ASSET";
    WorkspaceEntityType["MARKET"] = "MARKET";
    WorkspaceEntityType["MARKETBLENDED"] = "MARKETBLENDED";
})(WorkspaceEntityType || (WorkspaceEntityType = {}));
const GetWorkspaceEntityType = {
    [EntityType.Portfolio]: WorkspaceEntityType.PORTFOLIO,
    [EntityType.Fund]: WorkspaceEntityType.FUND,
    [EntityType.FundSeries]: WorkspaceEntityType.FUND_SERIES,
    [EntityType.Manager]: WorkspaceEntityType.MANAGER,
    [EntityType.Asset]: WorkspaceEntityType.ASSET,
    [EntityType.Market]: WorkspaceEntityType.MARKET
};
export const workspaceEntityTypeDataToEntityTypeMap = (entityType, subType) => {
    if (entityType === EntityType.Market && subType === language.en.markets.Blended) {
        return WorkspaceEntityType.MARKETBLENDED;
    }
    return GetWorkspaceEntityType[entityType];
};
export const workspaceEntityTypeDataToWorkspaceEntityTypeMap = (workspaceEntityType) => {
    switch (workspaceEntityType) {
        case WorkspaceEntityType.PORTFOLIO:
            return EntityType.Portfolio;
        case WorkspaceEntityType.FUND:
            return EntityType.Fund;
        case WorkspaceEntityType.FUND_SERIES:
            return EntityType.FundSeries;
        case WorkspaceEntityType.MANAGER:
            return EntityType.Manager;
        case WorkspaceEntityType.ASSET:
            return EntityType.Asset;
        case WorkspaceEntityType.MARKET:
            return EntityType.Market;
        case WorkspaceEntityType.MARKETBLENDED:
            return language.en.markets.MarketBlended;
        default:
            return "";
    }
};
export var PrivacyOption;
(function (PrivacyOption) {
    PrivacyOption["Private"] = "Private";
    PrivacyOption["Public"] = "Public";
})(PrivacyOption || (PrivacyOption = {}));
export var AssetClass;
(function (AssetClass) {
    AssetClass["PE"] = "PE";
    AssetClass["RE"] = "RE";
    AssetClass["PD"] = "PD";
    AssetClass["INFRA"] = "INFRA";
    AssetClass["SEC"] = "SEC";
    AssetClass["ALL"] = "ALL";
})(AssetClass || (AssetClass = {}));
export var CurrentWorkspaceModalType;
(function (CurrentWorkspaceModalType) {
    CurrentWorkspaceModalType["Edit"] = "Edit";
    CurrentWorkspaceModalType["Duplicate"] = "Duplicate";
})(CurrentWorkspaceModalType || (CurrentWorkspaceModalType = {}));
export var PageType;
(function (PageType) {
    PageType["PRINT"] = "PRINT";
    PageType["SCREEN"] = "SCREEN";
})(PageType || (PageType = {}));
export var PageSize;
(function (PageSize) {
    PageSize["UNDEFINED_PAGE_SIZE"] = "UNDEFINED_PAGE_SIZE";
    PageSize["A4"] = "A4";
    PageSize["A3"] = "A3";
    PageSize["LETTER"] = "LETTER";
    PageSize["LEGAL"] = "LEGAL";
})(PageSize || (PageSize = {}));
export var PageMargin;
(function (PageMargin) {
    PageMargin["UNDEFINED_PAGE_MARGIN"] = "UNDEFINED_PAGE_MARGIN";
    PageMargin["M_5MM"] = "M_5MM";
    PageMargin["M_10MM"] = "M_10MM";
    PageMargin["M_15MM"] = "M_15MM";
    PageMargin["M_20MM"] = "M_20MM";
})(PageMargin || (PageMargin = {}));
